/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { StoreContext } from '../stores/RootStore';

const useStores = () => React.useContext(StoreContext);
export default useStores;
